import zenscroll from "zenscroll";

("use strict");

const smoothScroll = {
  init: function () {
    var edgeOffset = 0;
    var header = document.querySelector("header");
    if (header != null) {
      edgeOffset += header.offsetHeight;
    }
    var stickyBreadcrumb = document.querySelector(".breadcrumb-wrapper.sticky");
    if (stickyBreadcrumb != null) {
      edgeOffset += stickyBreadcrumb.offsetHeight;
    }
    zenscroll.setup(null, edgeOffset);
  },
};

export default smoothScroll.init();
